import React from "react";
import Context from "../../../../Context";
import Blocker from "../../../Misc/Blocker";
export default class WorkdocUndertake extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      pending: false,
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let items = await this.context.api.qa("/undertake/item/list", {
      filter: { documentid: this.props.id },
      orderby: ["itemid ASC"],
    });

    this.setState({ pending: false, items });
  };
  render() {
    const { items, pending } = this.state;
    const document = this.props.document || {};
    return (
      <>
        <Blocker on={pending} hAuto>
          <h5>{document.label}</h5>
          <div className="mb-4">
            <div>
              Передать заведование к:{" "}
              <span className="text-muted">{document.receiptname}</span>
            </div>
            <div>
              Судно: <span className="text-muted">{document.shipname}</span>
            </div>
            {document.description && (
              <div>
                Комментарий:{" "}
                <span className="text-muted">{document.description}</span>
              </div>
            )}
          </div>
          <table className="table">
            <thead>
              <tr>
                <th width="60%">Оборудование:</th>
                <th>Передать заведование от:</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => {
                let line = item || {};
                let element = line.element || {};
                let transfer = line.transfer || {};
                return (
                  <tr key={item.itemid}>
                    <td>
                      {element.modelname}{" "}
                      <div className="small text-muted">{element.identity}</div>
                    </td>
                    <td>
                      {transfer.fullname || (
                        <span className="text-muted">Нет</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Blocker>
      </>
    );
  }
}
